export default "__VITE_ASSET__Be93l8EZ__"